import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from 'src/utils/baseQuery';

export interface CampaignListType {
  campaignName: string;
  campaignType: string;
  configId: string;
  createdAt: string;
  id: string;
  teamId: string | null;
  tenantId: string;
  updatedAt: string;
}

export const campaignApi = createApi({
  reducerPath: 'campaignApi',
  baseQuery,
  endpoints: (builder) => ({
    getCampaignList: builder.mutation({
      query: (campaignPayload) => ({
        url: 'campaign/list',
        method: 'POST',
        body:
          Object.keys(campaignPayload).length > 0
            ? campaignPayload
            : {
                filters: [],
              },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: {
        data?: { campaign?: { list?: CampaignListType[]; total: number } };
      }) => ({
        list: response?.data?.campaign?.list ?? [],
        total: response?.data?.campaign?.total ?? 0,
      }),
    }),
    addCampaign: builder.mutation({
      query: (campaignPayload) => ({
        url: 'campaign/add',
        method: 'POST',
        body: campaignPayload,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    triggerCampaign: builder.mutation({
      query: (campaignid) => ({
        url: 'campaign/trigger',
        method: 'POST',
        body: { id: campaignid },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    deleteCampaign: builder.mutation({
      query: (ids) => ({
        url: 'campaign/delete',
        method: 'POST',
        body: { ids },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    detailCampaign: builder.mutation({
      query: (id) => ({
        url: 'campaign/details',
        method: 'POST',
        body: { id },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    updateCampaign:builder.mutation({
      query: (updateQuery) => ({
        url: 'campaign/update',
        method: 'POST',
        body: updateQuery ,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    campaignDetail: builder.mutation({
      query: (id) => ({
        url: 'campaign/details',
        method: 'POST',
        body: { id },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
});

export const {
  useGetCampaignListMutation,
  useAddCampaignMutation,
  useTriggerCampaignMutation,
  useDeleteCampaignMutation,
  useDetailCampaignMutation,
  useUpdateCampaignMutation,
  useCampaignDetailMutation,
} = campaignApi;
